/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('es6-promise/auto');

//window.Vue = require('vue');
//window.Event = new Vue();

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue ->
 * <example-component></example-component>
 */

//const files = require.context('./', true, /\.vue$/i);
//files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component',

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//                         el: '#app'
//                     });

// slide out menu
require('@cmyee/pushy/js/pushy.min');
require('slick-carousel/slick/slick');

//tooltop
$(function() {
    $('[data-toggle="tooltip"]').tooltip();
});

//horizontal banner
require('./includes/horizontal-banner');

//text slider
require('./includes/text-slider');

//testimonials slider
require('./includes/testimonial-slider');

//logo slider
require('./includes/logo-slider');

//
require('./includes/data-table');

require('./includes/links');

require('./includes/featured-articles');

$(document).ready(function() {
    $('.menu-btn, .pushy-menu a[href="#"]').click(function(e) {
        e.preventDefault();
    });
});

if($('#contact_form').length > 0) {
    $('#contact_form').submit(function(event) {
        if($('#contact_form input[name="g-recaptcha-response"]').length < 1) {
            // we stoped it
            event.preventDefault();
            // needs for recaptacha ready
            grecaptcha.ready(function() {
                // do request for recaptcha token
                // response is promise with passed token
                grecaptcha.execute('6Le9M50UAAAAAGVYRxlYu7hxt4Ka7__AwXfXzLlF', {action: 'form/submit'}).then(function(token) {
                    // add token to form
                    $('#contact_form').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">').submit();
                });
            });
        }
    });
}
if($('#newsletter_form').length > 0) {
    $('#newsletter_form').submit(function(event) {
        if($('#newsletter_form input[name="g-recaptcha-response"]').length < 1) {
            // we stoped it
            event.preventDefault();
            // needs for recaptacha ready
            grecaptcha.ready(function() {
                // do request for recaptcha token
                // response is promise with passed token
                grecaptcha.execute('6Le9M50UAAAAAGVYRxlYu7hxt4Ka7__AwXfXzLlF', {action: 'form/submit'}).then(function(token) {
                    // add token to form
                    $('#newsletter_form').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">').submit();
                });
            });
        }
    });
}
if($('#register_form').length > 0) {
    $('#register_form').submit(function(event) {
        if($('#register_form input[name="g-recaptcha-response"]').length < 1) {
            // we stoped it
            event.preventDefault();
            // needs for recaptacha ready
            grecaptcha.ready(function() {
                // do request for recaptcha token
                // response is promise with passed token
                grecaptcha.execute('6Le9M50UAAAAAGVYRxlYu7hxt4Ka7__AwXfXzLlF', {action: 'form/submit'}).then(function(token) {
                    // add token to form
                    $('#register_form').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">').submit();
                });
            });
        }
    });
}
$(document).ready(function() {
    if($('.image-slider').length > 0) {
        $('.image-slider').slick({
                                     dots: false,
                                     infinite: true,
                                     speed: 300,
                                     slidesToShow: 4,
                                     arrows: true,
                                     draggable: false,
                                     autoplay: false,
                                     autoplaySpeed: 4000,
                                     adaptiveHeight: false,
                                     fade: false,
                                     cssEase: 'linear',
                                     responsive: [{
                                         breakpoint: 992, settings: {
                                             slidesToShow: 3, draggable: true, arrows: false
                                         }
                                     }]
                                 });
    }

});

$(document).on('click', '.search-toggle', function(e) {
    e.preventDefault();

    if($('.main-nav__icons .search-toggle').hasClass('closed')) {
        $('.main-nav__icons .search-toggle').removeClass('closed');
        $('.main-nav__icons .search-toggle').addClass('open');

        $('.main-nav__menu').addClass('show-search');
        $('.main-nav__menu .form-control').focus();

    } else {
        if($('.main-nav__icons .search-toggle').hasClass('open')) {
            $('.main-nav__icons .search-toggle').removeClass('open');
            $('.main-nav__icons .search-toggle').addClass('closed');
            $('.main-nav__menu').removeClass('show-search');
        }
    }

});

// PREVENT INSIDE CLICK DROPDOWN
$('.dropdown-menu').on("click.bs.dropdown", function(e) {
    e.stopPropagation();
});


require('lightgallery/dist/js/lightgallery-all');

$('[data-gallery]').lightGallery({
    share: false,
    zoom: false,
    actualSize: false,
    fullScreen: false,
    download: false,
    thumbnail: false,
    autoplay: false,
    autoplayControls: false,
    selector: '[data-src]',
    counter: true,
    centered: true,
});

$(".interactive-table").lightGallery({
    share: false,
    zoom: false,
    actualSize: false,
    fullScreen: false,
    download: false,
    thumbnail: false,
    autoplay: false,
    autoplayControls: false,
    selector: "[data-src]",
    counter: true,
    centered: true
});


